export const mapPeriodsOptions = periods => {
  const mappedPeriods =
    periods?.reduce(
      (prevValues, actValue) => ({ ...prevValues, [actValue?.periodId]: actValue?.periodId }),
      {}
    ) || {};
  return mappedPeriods;
};
